<div *ngIf="attachment" [class.mb-3]="message?.text" class="message-attachments-compact">
  <div class="card">
    <div class="card-body p-3 media">
      <div *ngIf="attachment?.thumb?.file_uri; else iconThumb" class="mr-3">
        <img loading="lazy" width="50" [src]="attachment.thumb.file_uri" class="rounded img-prev img-fluid" />
      </div>
      <ng-template #iconThumb>
        <ng-container [ngSwitch]="attachment.type">
          <ng-template ngSwitchCase="video_note">
            <span class="icon-shape text-white bg-primary mr-5">
              <i-feather name="video"></i-feather>
            </span>
          </ng-template>
          <ng-template ngSwitchCase="animation">
            <span class="icon-shape text-white bg-primary mr-5">
              <i-feather name="film"></i-feather>
            </span>
          </ng-template>
          <ng-template ngSwitchCase="video">
            <span class="icon-shape text-white bg-primary mr-5">
              <i-feather name="video"></i-feather>
            </span>
          </ng-template>
          <ng-template ngSwitchCase="photo">
            <span class="icon-shape text-white bg-primary mr-5">
              <i-feather name="image"></i-feather>
            </span>
          </ng-template>
          <ng-template ngSwitchCase="audio">
            <span class="icon-shape text-white bg-primary mr-5">
              <i-feather name="music"></i-feather>
            </span>
          </ng-template>
          <ng-template ngSwitchCase="web_page">
            <span class="icon-shape text-white bg-primary mr-5">
              <i-feather name="external-link"></i-feather>
            </span>
          </ng-template>
          <ng-template ngSwitchCase="contact">
            <app-avatar
              [id]="attachment.user_id"
              [type]="'private'"
              [avatar]="attachment.user.avatar"
              [avatarFileId]="attachment.user.avatar_file_id"
              [avatarFileUniqueId]="attachment.user.avatar_file_unique_id"
              class="avatar mr-5"
            ></app-avatar>
          </ng-template>
          <ng-template ngSwitchCase="location">
            <span class="icon-shape text-white bg-primary mr-5">
              <i-feather name="map-pin"></i-feather>
            </span>
          </ng-template>
          <ng-template ngSwitchCase="video_iframe">
            <span class="icon-shape text-white bg-primary mr-5">
              <i-feather name="video"></i-feather>
            </span>
          </ng-template>
          <ng-template ngSwitchCase="gift">
            <span class="icon-shape text-white bg-primary mr-5">
              <i-feather name="gift"></i-feather>
            </span>
          </ng-template>
          <ng-template ngSwitchCase="call">
            <span class="icon-shape text-white bg-primary mr-5">
              <i-feather name="phone-call"></i-feather>
            </span>
          </ng-template>
          <ng-template ngSwitchCase="wall">
            <span class="icon-shape text-white bg-primary mr-5">
              <i-feather name="book-open"></i-feather>
            </span>
          </ng-template>
          <ng-template ngSwitchDefault>
            <app-icon-mime [mime]="attachment.mime_type" class="mr-5"></app-icon-mime>
          </ng-template>
        </ng-container>
      </ng-template>
      <div class="media-body text-dark overflow-hidden flex-fill">
        <div class="text-truncate font-medium text-reset">
          <div [title]="attachment.compact_title">
            {{ attachment.compact_title || attachment.file_name || attachment.name || attachment.performer }}
          </div>
        </div>
        <div class="text-muted small text-truncate font-medium text-reset">
          <div class="text-primary" *ngIf="message.attachments?.length > 1">
            Еще {{ message.attachments?.length - 1 }}
          </div>
          <div [title]="attachment.compact_description" *ngIf="message.attachments?.length == 1">
            {{
              attachment.compact_description || attachment.file_size_convert || attachment.title || attachment.mime_type
            }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--<i-feather name="corner-right-up"></i-feather>-->
</div>
